import React from 'react'

import { classNames } from '@lib/simpleFn'

type WrongAnswerButtonProps = {
  isWrong: boolean
  wrongButtonHandler: () => void
}

const WrongAnswerButton: React.FC<WrongAnswerButtonProps> = ({ isWrong, wrongButtonHandler }) => {
  return (
    <button
      className={classNames(
        'border px-2 rounded-lg ml-auto',
        isWrong ? 'bg-gray-400' : '',
        'hidden'
      )}
      onClick={wrongButtonHandler}
    >
      {isWrong ? '해제' : '오답'}
    </button>
  )
}

export default React.memo(WrongAnswerButton)
